import { QueryProvider } from "./api/QueryProvider";
import { router } from "./routes/router";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <QueryProvider>
      <RouterProvider router={router} />
      <Toaster richColors closeButton />
    </QueryProvider>
  );
}

export default App;